import React from 'react';
import styled from 'styled-components'; 
import { Link } from 'react-router-dom'; 
import constants from 'utils/constants';

export default function ChallengeReward({rewards}) {   
	return ( 
		<RewardSection>
			<SectionHeader>
				<SectionTitle>챌린지 리워드</SectionTitle>
			</SectionHeader>
			<ProofList>
			{(rewards && rewards.map((reward, index)=>{ 
				return (
					<RewardItemWrapper key={`challenge-reward-index-${index}`} itemNum={rewards.length} >
						<RewardItem>
							<ProductImgWrapper>
								<ProductImg src={`${constants.imagePath}/campaign_reward_img/${reward['filename']}`}/>
								{((reward['type']==='current') && (
									<RewardImgTag>이번단계 리워드✨</RewardImgTag>
								))}
								{((reward['type']==='prev') && (
									<RewardImgTag>이전단계 리워드✨</RewardImgTag>
								))}
								{((reward['type']==='next') && (
									<RewardImgTag>다음단계 리워드✨</RewardImgTag>
								))}
							</ProductImgWrapper>
							<ProductNameWrapper>
							<ProductName>{`${reward['text']}`}</ProductName>
							</ProductNameWrapper>
							<ProductBtnWrapper>
							{
								(reward?.link && (<ProductExternalLink href={reward.link} target="_blank">제품 더보기</ProductExternalLink>))
							}
							{
								(reward?.path && (<ProductPath to={reward.path}>제품 더보기</ProductPath>))
							}
							</ProductBtnWrapper>
						</RewardItem>
					</RewardItemWrapper>
					);
			}))} 
			</ProofList>
		</RewardSection>
		);
}
export const RewardSection = styled.div``
export const SectionHeader = styled.div`
padding : 0 calc(100vw*(20/375));
margin-bottom : calc(100vw*(18/375));
`
export const SectionTitle = styled.span`
font-style: normal;
font-weight: 700;
font-size: calc(100vw*(18/375));
line-height: calc(100vw*(26/375));
color: #121212;
`
export const TextBox = styled.div`
width: 100%; 
height: auto;
border-radius: calc(100vw*(5/375));
margin-bottom: calc(100vw * (34 / 375)); 
`
export const ProofList = styled.div`  
display: flex; 
flex-wrap: nowrap; 
overflow-x: scroll;    
padding : 0 calc(100vw*(20/375));
padding-bottom : calc(100vw*(19/375));
&::-webkit-scrollbar {
	display: none;
}
`

export const RewardItemWrapper = styled.div`   
width : 50%;
flex: 0 0 auto; 

${(props)=>(props['itemNum'] !== 2)
	?`padding-right:calc(100vw*(14/375));`
	:`
	&:first-child{
		padding-right:calc(100vw*(7/375));	
	}
	&:last-child{
		padding-left:calc(100vw*(7/375));	
	}
	`
}
`  
export const RewardItem = styled.div`    
background: #FFFFFF;
box-shadow: 0px 0px 20px rgba(191, 191, 191, 0.5);
border-radius: calc(100vw*(10/375));
`  

export const ProductImgWrapper = styled.div`
position : relative;
border-top-left-radius: calc(100vw*(10/375));
border-top-right-radius: calc(100vw*(10/375));
overflow: hidden;
`
export const ProductImg = styled.img``

export const RewardImgTag = styled.div`
	position : absolute;
	top : calc(100vw*(5/375));
	left : calc(100vw*(5/375));
	background: rgba(18, 18, 18, 0.75);
	border-radius: calc(100vw*(7/375));
	padding : calc(100vw*(5/375)) calc(100vw*(5/375)) calc(100vw*(6/375)) calc(100vw*(7/375));
	font-style: normal;
	font-weight: 500;
	font-size: calc(100vw*(12/375));
	line-height: calc(100vw*(17/375));

	color: #FFFFFF;
`

export const ProductNameWrapper = styled.div`
min-height: calc(100vw*(57/375));
display: flex;
flex-flow: column;
justify-content:center;
align-items: center;
`
export const ProductName = styled.div`
font-style: normal;
font-weight: 500;
font-size: calc(100vw*(14/375));
line-height: 150%;

display: flex;
align-items: center;
text-align: center;
font-feature-settings: 'tnum' on, 'lnum' on;

color: #121212;

padding : 0 calc(100vw*(10/375));

overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
`
export const ProductBtnWrapper = styled.div`
padding : 0 calc(100vw*(11.5/375)) calc(100vw*(10/375)) calc(100vw*(11.5/375));
`

export const ProductPath = styled(Link)`
display: inline-block;
width : 100%;
padding : calc(100vw*(5/375)) 0 calc(100vw*(6/375)) 0;
text-align: center;
font-style: normal;
font-weight: 600;
font-size: calc(100vw*(12/375));
line-height: calc(100vw*(17/375));
color: #4E4E4E;
background: #F7F7F7;
border-radius: calc(100vw*(3/375));
`
export const ProductExternalLink = styled.a`
display: inline-block;
width : 100%;
padding : calc(100vw*(5/375)) 0 calc(100vw*(6/375)) 0;
text-align: center;
font-style: normal;
font-weight: 600;
font-size: calc(100vw*(12/375));
line-height: calc(100vw*(17/375));
color: #4E4E4E;
background: #F7F7F7;
border-radius: calc(100vw*(3/375));
`
